<p-dialog
    [modal]="true"
    appendTo="body"
    [(visible)]="viewEmailVisible"
    [maximizable]="true"
    [style]="{width: '90vw', height: '90vh'}"
    [contentStyle]="{'overflow-y': 'auto', 'height': 'calc(100% - 1rem)'}"
    (onHide)="selectedViewEmail = null">
    <ng-template pTemplate="header">
        <div class="flex flex-column gap-1">
            <span class="font-semibold text-lg">{{ selectedViewEmail?.subject }}</span>
            <span class="text-sm text-color-secondary">
                From: {{ selectedViewEmail?.from }} &nbsp;|&nbsp; {{ selectedViewEmail?.dateReceived | date:'medium' }}
            </span>
        </div>
    </ng-template>
    <div [innerHtml]="selectedViewEmail?.body"></div>
</p-dialog>

<p-panel>
    <ng-template pTemplate="header">
        <div><h4>Inbox</h4></div>
    </ng-template>
    <p-table [value]="sortedEmails" [paginator]="sortedEmails.length > 5" sortMode="single" [rows]="5" sortField="dateReceived" [sortOrder]="-1">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="dateReceived">Received Date <p-sortIcon field="dateReceived" /></th>
                <th>From</th>
                <th>Subject</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-email>
            <tr [style.font-weight]="email.read ? 'normal' : 'bold'">
                <td>{{ email.dateReceived | date: 'short' }}</td>
                <td><p-tag icon="pi pi-user" [rounded]="true" [value]="email.from"/></td>
                <td>{{ email.subject }}</td>
                <td>
                    <p-button icon="pi pi-eye" label="View" [text]="true" (onClick)="openViewEmail(email)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-panel>
